var map = {
	"./BackgroundRegistration.png": 4598,
	"./Chevron.png": 7605,
	"./Fastweb.png": 3983,
	"./Irideos.png": 309,
	"./Linkem.png": 2393,
	"./Mix.png": 5041,
	"./Notification.png": 2256,
	"./OpenFiber.png": 2654,
	"./background.png": 5665,
	"./hamburger.png": 7738,
	"./icon.png": 7334,
	"./logoright.png": 2162,
	"./search.png": 2305,
	"./tim.png": 9584
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2715;